import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrandRoutingModule} from "./brand-routing.module";
import {BrandEditComponent} from "./brand-edit/brand-edit.component";
import {FormsModule} from "@angular/forms";
import {SharedModule} from "../../shared/shared.module";
import {FlexModule} from "@angular/flex-layout";

@NgModule({
  declarations: [BrandEditComponent, BrandRoutingModule.components],
  imports: [
    CommonModule,
    BrandRoutingModule,
    FormsModule,
    SharedModule,
    FlexModule
  ],
  exports: [BrandRoutingModule.components],
})
export class BrandModule {
}
